export default __webpack_public_path__ + "static/media/magnifying-glass.eb2d989f.svg";